import Handlebars from 'handlebars';

export function articleTileBlock() {
    let itemPartial = require('../../views/blocks/articleTileBlock/tmpl/articleTileBlock.hbs');
    Handlebars.registerPartial('articleTileBlock', itemPartial);

    let template = `
        {{> articleTileBlock
            blk="articleTileBlock"
            ns="ArticleTileBlock"
        }}
    `;

    let precompiled = new Function('return ' + Handlebars.precompile(template))();
    return Handlebars.template(precompiled);
}

export function eventTileBlock() {
    let itemPartial = require('../../views/blocks/eventTileBlock/tmpl/eventTileBlock.hbs');
    Handlebars.registerPartial('eventTileBlock', itemPartial);

    let template = `
        {{> eventTileBlock
            wg="eventTileBlock"
            ns="EventTileBlock"
        }}
    `;

    let precompiled = new Function('return ' + Handlebars.precompile(template))();
    return Handlebars.template(precompiled);
}

export function courseTileTemplate() {
    let itemPartial = require('../../views/blocks/courseSearchResultItemBlock/tmpl/courseSearchResultItemBlock.hbs');
    Handlebars.registerPartial('courseSearchResultItemBlock', itemPartial);

    let template = `
        {{> courseSearchResultItemBlock
            blk="courseSearchResultItemBlock"
            ns="CourseSearchResultItemBlock"
        }}
    `;

    let precompiled = new Function('return ' + Handlebars.precompile(template))();
    return Handlebars.template(precompiled);
}

export function studyAreaTile() {
    let itemPartial = require('../../views/blocks/studyAreasListingBlock/tmpl/studyAreasTile.hbs');
    Handlebars.registerPartial('studyAreasTile', itemPartial);

    let template = `
        {{> studyAreasTile
            blk="studyAreasTile"
            ns="StudyAreasTile"
        }}
    `;
    let precompiled = new Function('return ' + Handlebars.precompile(template))();
    return Handlebars.template(precompiled);
}


export function filterTemplate() {

	// payload
	// "facets":[
	// 	{
	// 	   "groupName":"Date",
	// 	   "items":[
	// 		  {
	// 			 "groupName":"Date",
	// 			 "groupKey":"SearchPublishDate",
	// 			 "name":"November 2019",
	// 			 "key":"2019-11-01|2019-11-30",
	// 			 "count":1,
	// 			 "filtered":false
	// 		  }
	// 	   ]
	// 	}


	let template = `
		<div class="set">
			<div class="title">{{groupName}}</div>
			{{#each items as |subFilter|}}
			<a class="label text-decoration-none cursor-pointer">
				<span class="badge badge-primary badge-lg {{subFilter.filtered}}"
				data-key="{{key}}" data-groupkey="{{groupKey}}">{{subFilter.name}}</span>
			</a>
			{{/each}}
		</div>
	`;
    let precompiled = new Function('return ' + Handlebars.precompile(template))();
    return Handlebars.template(precompiled);
}
